// helpers/useHandleRequest.js
import { useNavigate } from 'react-router-dom';
import { useData } from '../context/DataContext';
import { useLoadingBar } from '../context/LoadingBarContext';

const useHandleRequest = () => {
    const { fetchData } = useData();
    const navigate = useNavigate();
    const loadingBarRef = useLoadingBar();

    const handleRequestAndNavigate = async (event, destinationUrl, apiUrl, pageKey) => {
        event.preventDefault(); // جلوگیری از هدایت پیش‌فرض

        loadingBarRef.current.start(); // شروع پروگرس بار

        try {
            // درخواست به API
            await fetchData(pageKey, apiUrl); // داده‌ها برای صفحه خاص دریافت می‌شود

            // پس از دریافت داده‌ها، به مقصد هدایت می‌شود
            navigate(destinationUrl);
        } catch (error) {
            console.error("Error during request", error);
        } finally {
            loadingBarRef.current.complete(); // اتمام پروگرس بار
        }
    };

    return { handleRequestAndNavigate };
};

export default useHandleRequest;
